import { SelectOptionValues } from '../../React/Common/Components/Selects/Types'

/**
 * Utilities for building select options from value lists with i18n labels.
 */
export class SelectOptionUtils {
    /**
     * Builds an array of select options from values, with labels resolved via a key prefix and getLabel callback.
     *
     * @param sourceValues - Values that become the option values.
     * @param labelKeyPrefix - Prefix used to build the i18n key for each label (e.g. "CX_Score_Licences_").
     * @param getLabel - Function that resolves the full i18n key to the display label (e.g. language.get).
     * @returns Array of { label, value } suitable for use as SelectOptions.
     */
    public static mapLanguageFileToSelectionOptions<T extends SelectOptionValues>(
        sourceValues: readonly T[],
        labelKeyPrefix: string,
        getLabel: (i18nKey: string) => string
    ): Array<{ label: string; value: T }> {
        return sourceValues.map((value: T): { label: string; value: T } => ({
            label: getLabel(`${labelKeyPrefix}${value}`),
            value
        }))
    }
}
